/**
 * Price Restructure
 * Simply restacks the price elements vertically
 */

function restructurePrice() {
  const priceWrap = document.querySelector('[data-product-price-wrap]');
  if (!priceWrap) return;

  // Just add a class to trigger CSS layout changes
  priceWrap.classList.add('price-stacked');
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', restructurePrice);
} else {
  restructurePrice();
}

// Re-run when variant changes
document.addEventListener('variant:change', restructurePrice);